import * as React from 'react'
import colors from 'theme/colors'

const SvgComponent = ({
  color = colors.borderGrey,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 32
  const h = 32
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.11963 8H29.1196V10H3.11963V8ZM3.11963 15H29.1196V17H3.11963V15ZM29.1196 22H3.11963V24H29.1196V22Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
